export default __webpack_public_path__ + "static/greenfix-307904f4fda3287343b5c2f5bd1ff8a2.png";